// extracted by mini-css-extract-plugin
export var mt0 = "multi-form-module--mt-0--7f530";
export var mt1 = "multi-form-module--mt-1--dc23c";
export var mt2 = "multi-form-module--mt-2--0e777";
export var mt3 = "multi-form-module--mt-3--95d87";
export var mt4 = "multi-form-module--mt-4--413c2";
export var mt5 = "multi-form-module--mt-5--71880";
export var mt6 = "multi-form-module--mt-6--2b515";
export var multiForm = "multi-form-module--multi-form--41a81";
export var multiForm__el = "multi-form-module--multi-form__el--768ca";
export var multiForm__form = "multi-form-module--multi-form__form--c0e74";
export var multiForm__forms = "multi-form-module--multi-form__forms--033c9";